import React from "react";
import { useCheckIframe } from "../../../hooks/useCheckIframe.ts";

interface IProps {
  url: string;
  setUrl: (x: string) => void;
  id: string;
}

export const IframeClosed = ({ url, id, setUrl }: IProps) => {
  useCheckIframe(id, setUrl);
  return (
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    <iframe
      src={url}
      style={{
        maxWidth: "100%",
        height: "80vh",
      }}
    ></iframe>
  );
};
